import { parseISO, formatISO } from "date-fns";

export default {
  install(Vue, options) {
    Vue.prototype.$parseDate = (date) => {
      return formatISO(parseISO(date))
    }
    Vue.prototype.$today = () => {
      return formatISO(new Date());
    }
  }
}
